import React, { useEffect, useState } from "react";
import { CustomOutlinedDisabledTextField } from "../../../../../partials/content/Forms";
import { Card } from "react-bootstrap";
import { getOutlet } from "../../../../../services/sales/outletService";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
const OutletBasicInfo = ({ match }) => {
  const { reload } = useGlobalData();
  const { outletID = 0 } = match.params;
  const [outlet, setOutlet] = useState({
    ID: 0,
    outletName: "",
    addressEmail: "",
    addressPhone: "",
    address: "",
    city: "",
    province: "",
    countryName: "",
    postalCode: "",
    currency: {
      currencyCode: "",
    },
    thermalPrinterSizeName: "",
  });

  useEffect(() => {
    getOutletData(outletID);
  }, [outletID, reload]);

  async function getOutletData(outletID = 0) {
    if (outletID > 0) {
      const response = await getOutlet(outletID);
      const { data } = response.data;
      setOutlet(data.outlet);
    }
  }
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Card>
            <Card.Header>
              <i className="fas fa-th-large"></i>
              <span>
                <strong>Outlet Basic Info</strong>
              </span>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <CustomOutlinedDisabledTextField
                    label="Outlet Name"
                    value={outlet.outletName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Phone Number"
                    value={outlet.addressPhone}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Email"
                    value={outlet.addressEmail}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Currency"
                    value={outlet.currency.currencyCode}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Thermal Printer Size"
                    value={outlet.thermalPrinterSizeName}
                  />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <CustomOutlinedDisabledTextField
                    label="Address"
                    value={outlet.address}
                  />
                  <CustomOutlinedDisabledTextField
                    label="City"
                    value={outlet.city}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Province / State"
                    value={outlet.province}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Country"
                    value={outlet.countryName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Postal Code"
                    value={outlet.postalCode}
                  />
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default OutletBasicInfo;
